import { Atoms } from 'shared/atoms';
import { polyfill } from '@lemon8/web-scaffold/polyfill';
import { setupJotai, setupFetch, startHydrate, collectPreRenderedStyles } from '@lemon8/web-app-shared/ssr';

import 'core-js/es/array/at';
import 'core-js/es/object/has-own';

window.atoms = Atoms;

setupJotai();
setupFetch();
collectPreRenderedStyles();

void polyfill().then(startHydrate);
